export default __webpack_public_path__ + "static/media/Group1723.c5c93e32.svg";